/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppWebhooksRouteImport } from './routes/_app/webhooks'
import { Route as AppTemplatesRouteImport } from './routes/_app/templates'
import { Route as AppRulesRouteImport } from './routes/_app/rules'
import { Route as AppFinanceRouteImport } from './routes/_app/finance'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppAutomationScheduledRouteImport } from './routes/_app/automation-scheduled'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppPricingStrategiesIndexRouteImport } from './routes/_app/pricing-strategies.index'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox.index'
import { Route as AppGuestsIndexRouteImport } from './routes/_app/guests.index'
import { Route as AppFinanceIndexRouteImport } from './routes/_app/finance.index'
import { Route as AppBookingsIndexRouteImport } from './routes/_app/bookings.index'
import { Route as AppApartmentsIndexRouteImport } from './routes/_app/apartments.index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users.$id'
import { Route as AppSettingsFinanceRouteImport } from './routes/_app/settings.finance'
import { Route as AppSettingsChannelsRouteImport } from './routes/_app/settings.channels'
import { Route as AppPricingStrategiesIdRouteImport } from './routes/_app/pricing-strategies.$id'
import { Route as AppInboxIdRouteImport } from './routes/_app/inbox.$id'
import { Route as AppGuestsIdRouteImport } from './routes/_app/guests.$id'
import { Route as AppFinanceSubmitRouteImport } from './routes/_app/finance.submit'
import { Route as AppFinanceSubmissionsRouteImport } from './routes/_app/finance.submissions'
import { Route as AppFinanceRulesRouteImport } from './routes/_app/finance.rules'
import { Route as AppFinanceQueueRouteImport } from './routes/_app/finance.queue'
import { Route as AppFinancePeriodsRouteImport } from './routes/_app/finance.periods'
import { Route as AppFinanceEventsRouteImport } from './routes/_app/finance.events'
import { Route as AppBookingsIdRouteImport } from './routes/_app/bookings.$id'
import { Route as AppApartmentsNewRouteImport } from './routes/_app/apartments.new'
import { Route as AppApartmentsIdRouteImport } from './routes/_app/apartments.$id'
import { Route as AppFinanceMovementsIndexRouteImport } from './routes/_app/finance.movements.index'
import { Route as AppFinanceAccountsIndexRouteImport } from './routes/_app/finance.accounts.index'
import { Route as AppFinanceRulesIdRouteImport } from './routes/_app/finance.rules.$id'
import { Route as AppFinanceMovementsIdRouteImport } from './routes/_app/finance.movements.$id'
import { Route as AppFinanceExpectedIdRouteImport } from './routes/_app/finance.expected.$id'
import { Route as AppFinanceAccountsIdRouteImport } from './routes/_app/finance.accounts.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWebhooksRoute = AppWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplatesRoute = AppTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppRoute,
} as any)
const AppRulesRoute = AppRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceRoute = AppFinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationScheduledRoute = AppAutomationScheduledRouteImport.update({
  id: '/automation-scheduled',
  path: '/automation-scheduled',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingStrategiesIndexRoute =
  AppPricingStrategiesIndexRouteImport.update({
    id: '/pricing-strategies/',
    path: '/pricing-strategies/',
    getParentRoute: () => AppRoute,
  } as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppRoute,
} as any)
const AppGuestsIndexRoute = AppGuestsIndexRouteImport.update({
  id: '/guests/',
  path: '/guests/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceIndexRoute = AppFinanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppBookingsIndexRoute = AppBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AppRoute,
} as any)
const AppApartmentsIndexRoute = AppApartmentsIndexRouteImport.update({
  id: '/apartments/',
  path: '/apartments/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsFinanceRoute = AppSettingsFinanceRouteImport.update({
  id: '/settings/finance',
  path: '/settings/finance',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsChannelsRoute = AppSettingsChannelsRouteImport.update({
  id: '/settings/channels',
  path: '/settings/channels',
  getParentRoute: () => AppRoute,
} as any)
const AppPricingStrategiesIdRoute = AppPricingStrategiesIdRouteImport.update({
  id: '/pricing-strategies/$id',
  path: '/pricing-strategies/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxIdRoute = AppInboxIdRouteImport.update({
  id: '/inbox/$id',
  path: '/inbox/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGuestsIdRoute = AppGuestsIdRouteImport.update({
  id: '/guests/$id',
  path: '/guests/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceSubmitRoute = AppFinanceSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceSubmissionsRoute = AppFinanceSubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceRulesRoute = AppFinanceRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceQueueRoute = AppFinanceQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinancePeriodsRoute = AppFinancePeriodsRouteImport.update({
  id: '/periods',
  path: '/periods',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceEventsRoute = AppFinanceEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppBookingsIdRoute = AppBookingsIdRouteImport.update({
  id: '/bookings/$id',
  path: '/bookings/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppApartmentsNewRoute = AppApartmentsNewRouteImport.update({
  id: '/apartments/new',
  path: '/apartments/new',
  getParentRoute: () => AppRoute,
} as any)
const AppApartmentsIdRoute = AppApartmentsIdRouteImport.update({
  id: '/apartments/$id',
  path: '/apartments/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceMovementsIndexRoute =
  AppFinanceMovementsIndexRouteImport.update({
    id: '/movements/',
    path: '/movements/',
    getParentRoute: () => AppFinanceRoute,
  } as any)
const AppFinanceAccountsIndexRoute = AppFinanceAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceRulesIdRoute = AppFinanceRulesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppFinanceRulesRoute,
} as any)
const AppFinanceMovementsIdRoute = AppFinanceMovementsIdRouteImport.update({
  id: '/movements/$id',
  path: '/movements/$id',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceExpectedIdRoute = AppFinanceExpectedIdRouteImport.update({
  id: '/expected/$id',
  path: '/expected/$id',
  getParentRoute: () => AppFinanceRoute,
} as any)
const AppFinanceAccountsIdRoute = AppFinanceAccountsIdRouteImport.update({
  id: '/accounts/$id',
  path: '/accounts/$id',
  getParentRoute: () => AppFinanceRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/automation-scheduled': typeof AppAutomationScheduledRoute
  '/calendar': typeof AppCalendarRoute
  '/finance': typeof AppFinanceRouteWithChildren
  '/rules': typeof AppRulesRoute
  '/templates': typeof AppTemplatesRoute
  '/webhooks': typeof AppWebhooksRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/apartments/$id': typeof AppApartmentsIdRoute
  '/apartments/new': typeof AppApartmentsNewRoute
  '/bookings/$id': typeof AppBookingsIdRoute
  '/finance/events': typeof AppFinanceEventsRoute
  '/finance/periods': typeof AppFinancePeriodsRoute
  '/finance/queue': typeof AppFinanceQueueRoute
  '/finance/rules': typeof AppFinanceRulesRouteWithChildren
  '/finance/submissions': typeof AppFinanceSubmissionsRoute
  '/finance/submit': typeof AppFinanceSubmitRoute
  '/guests/$id': typeof AppGuestsIdRoute
  '/inbox/$id': typeof AppInboxIdRoute
  '/pricing-strategies/$id': typeof AppPricingStrategiesIdRoute
  '/settings/channels': typeof AppSettingsChannelsRoute
  '/settings/finance': typeof AppSettingsFinanceRoute
  '/users/$id': typeof AppUsersIdRoute
  '/apartments/': typeof AppApartmentsIndexRoute
  '/bookings/': typeof AppBookingsIndexRoute
  '/finance/': typeof AppFinanceIndexRoute
  '/guests/': typeof AppGuestsIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/pricing-strategies/': typeof AppPricingStrategiesIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/finance/accounts/$id': typeof AppFinanceAccountsIdRoute
  '/finance/expected/$id': typeof AppFinanceExpectedIdRoute
  '/finance/movements/$id': typeof AppFinanceMovementsIdRoute
  '/finance/rules/$id': typeof AppFinanceRulesIdRoute
  '/finance/accounts/': typeof AppFinanceAccountsIndexRoute
  '/finance/movements/': typeof AppFinanceMovementsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/automation-scheduled': typeof AppAutomationScheduledRoute
  '/calendar': typeof AppCalendarRoute
  '/rules': typeof AppRulesRoute
  '/templates': typeof AppTemplatesRoute
  '/webhooks': typeof AppWebhooksRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/apartments/$id': typeof AppApartmentsIdRoute
  '/apartments/new': typeof AppApartmentsNewRoute
  '/bookings/$id': typeof AppBookingsIdRoute
  '/finance/events': typeof AppFinanceEventsRoute
  '/finance/periods': typeof AppFinancePeriodsRoute
  '/finance/queue': typeof AppFinanceQueueRoute
  '/finance/rules': typeof AppFinanceRulesRouteWithChildren
  '/finance/submissions': typeof AppFinanceSubmissionsRoute
  '/finance/submit': typeof AppFinanceSubmitRoute
  '/guests/$id': typeof AppGuestsIdRoute
  '/inbox/$id': typeof AppInboxIdRoute
  '/pricing-strategies/$id': typeof AppPricingStrategiesIdRoute
  '/settings/channels': typeof AppSettingsChannelsRoute
  '/settings/finance': typeof AppSettingsFinanceRoute
  '/users/$id': typeof AppUsersIdRoute
  '/apartments': typeof AppApartmentsIndexRoute
  '/bookings': typeof AppBookingsIndexRoute
  '/finance': typeof AppFinanceIndexRoute
  '/guests': typeof AppGuestsIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/pricing-strategies': typeof AppPricingStrategiesIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/finance/accounts/$id': typeof AppFinanceAccountsIdRoute
  '/finance/expected/$id': typeof AppFinanceExpectedIdRoute
  '/finance/movements/$id': typeof AppFinanceMovementsIdRoute
  '/finance/rules/$id': typeof AppFinanceRulesIdRoute
  '/finance/accounts': typeof AppFinanceAccountsIndexRoute
  '/finance/movements': typeof AppFinanceMovementsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/automation-scheduled': typeof AppAutomationScheduledRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/finance': typeof AppFinanceRouteWithChildren
  '/_app/rules': typeof AppRulesRoute
  '/_app/templates': typeof AppTemplatesRoute
  '/_app/webhooks': typeof AppWebhooksRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/apartments/$id': typeof AppApartmentsIdRoute
  '/_app/apartments/new': typeof AppApartmentsNewRoute
  '/_app/bookings/$id': typeof AppBookingsIdRoute
  '/_app/finance/events': typeof AppFinanceEventsRoute
  '/_app/finance/periods': typeof AppFinancePeriodsRoute
  '/_app/finance/queue': typeof AppFinanceQueueRoute
  '/_app/finance/rules': typeof AppFinanceRulesRouteWithChildren
  '/_app/finance/submissions': typeof AppFinanceSubmissionsRoute
  '/_app/finance/submit': typeof AppFinanceSubmitRoute
  '/_app/guests/$id': typeof AppGuestsIdRoute
  '/_app/inbox/$id': typeof AppInboxIdRoute
  '/_app/pricing-strategies/$id': typeof AppPricingStrategiesIdRoute
  '/_app/settings/channels': typeof AppSettingsChannelsRoute
  '/_app/settings/finance': typeof AppSettingsFinanceRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/apartments/': typeof AppApartmentsIndexRoute
  '/_app/bookings/': typeof AppBookingsIndexRoute
  '/_app/finance/': typeof AppFinanceIndexRoute
  '/_app/guests/': typeof AppGuestsIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/pricing-strategies/': typeof AppPricingStrategiesIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/finance/accounts/$id': typeof AppFinanceAccountsIdRoute
  '/_app/finance/expected/$id': typeof AppFinanceExpectedIdRoute
  '/_app/finance/movements/$id': typeof AppFinanceMovementsIdRoute
  '/_app/finance/rules/$id': typeof AppFinanceRulesIdRoute
  '/_app/finance/accounts/': typeof AppFinanceAccountsIndexRoute
  '/_app/finance/movements/': typeof AppFinanceMovementsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/automation-scheduled'
    | '/calendar'
    | '/finance'
    | '/rules'
    | '/templates'
    | '/webhooks'
    | '/auth/callback'
    | '/apartments/$id'
    | '/apartments/new'
    | '/bookings/$id'
    | '/finance/events'
    | '/finance/periods'
    | '/finance/queue'
    | '/finance/rules'
    | '/finance/submissions'
    | '/finance/submit'
    | '/guests/$id'
    | '/inbox/$id'
    | '/pricing-strategies/$id'
    | '/settings/channels'
    | '/settings/finance'
    | '/users/$id'
    | '/apartments/'
    | '/bookings/'
    | '/finance/'
    | '/guests/'
    | '/inbox/'
    | '/pricing-strategies/'
    | '/users/'
    | '/finance/accounts/$id'
    | '/finance/expected/$id'
    | '/finance/movements/$id'
    | '/finance/rules/$id'
    | '/finance/accounts/'
    | '/finance/movements/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/automation-scheduled'
    | '/calendar'
    | '/rules'
    | '/templates'
    | '/webhooks'
    | '/auth/callback'
    | '/'
    | '/apartments/$id'
    | '/apartments/new'
    | '/bookings/$id'
    | '/finance/events'
    | '/finance/periods'
    | '/finance/queue'
    | '/finance/rules'
    | '/finance/submissions'
    | '/finance/submit'
    | '/guests/$id'
    | '/inbox/$id'
    | '/pricing-strategies/$id'
    | '/settings/channels'
    | '/settings/finance'
    | '/users/$id'
    | '/apartments'
    | '/bookings'
    | '/finance'
    | '/guests'
    | '/inbox'
    | '/pricing-strategies'
    | '/users'
    | '/finance/accounts/$id'
    | '/finance/expected/$id'
    | '/finance/movements/$id'
    | '/finance/rules/$id'
    | '/finance/accounts'
    | '/finance/movements'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/automation-scheduled'
    | '/_app/calendar'
    | '/_app/finance'
    | '/_app/rules'
    | '/_app/templates'
    | '/_app/webhooks'
    | '/auth/callback'
    | '/_app/'
    | '/_app/apartments/$id'
    | '/_app/apartments/new'
    | '/_app/bookings/$id'
    | '/_app/finance/events'
    | '/_app/finance/periods'
    | '/_app/finance/queue'
    | '/_app/finance/rules'
    | '/_app/finance/submissions'
    | '/_app/finance/submit'
    | '/_app/guests/$id'
    | '/_app/inbox/$id'
    | '/_app/pricing-strategies/$id'
    | '/_app/settings/channels'
    | '/_app/settings/finance'
    | '/_app/users/$id'
    | '/_app/apartments/'
    | '/_app/bookings/'
    | '/_app/finance/'
    | '/_app/guests/'
    | '/_app/inbox/'
    | '/_app/pricing-strategies/'
    | '/_app/users/'
    | '/_app/finance/accounts/$id'
    | '/_app/finance/expected/$id'
    | '/_app/finance/movements/$id'
    | '/_app/finance/rules/$id'
    | '/_app/finance/accounts/'
    | '/_app/finance/movements/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/webhooks': {
      id: '/_app/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof AppWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/templates': {
      id: '/_app/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AppTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rules': {
      id: '/_app/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AppRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance': {
      id: '/_app/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automation-scheduled': {
      id: '/_app/automation-scheduled'
      path: '/automation-scheduled'
      fullPath: '/automation-scheduled'
      preLoaderRoute: typeof AppAutomationScheduledRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing-strategies/': {
      id: '/_app/pricing-strategies/'
      path: '/pricing-strategies'
      fullPath: '/pricing-strategies/'
      preLoaderRoute: typeof AppPricingStrategiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guests/': {
      id: '/_app/guests/'
      path: '/guests'
      fullPath: '/guests/'
      preLoaderRoute: typeof AppGuestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/': {
      id: '/_app/finance/'
      path: '/'
      fullPath: '/finance/'
      preLoaderRoute: typeof AppFinanceIndexRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/bookings/': {
      id: '/_app/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AppBookingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apartments/': {
      id: '/_app/apartments/'
      path: '/apartments'
      fullPath: '/apartments/'
      preLoaderRoute: typeof AppApartmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/finance': {
      id: '/_app/settings/finance'
      path: '/settings/finance'
      fullPath: '/settings/finance'
      preLoaderRoute: typeof AppSettingsFinanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/channels': {
      id: '/_app/settings/channels'
      path: '/settings/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof AppSettingsChannelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pricing-strategies/$id': {
      id: '/_app/pricing-strategies/$id'
      path: '/pricing-strategies/$id'
      fullPath: '/pricing-strategies/$id'
      preLoaderRoute: typeof AppPricingStrategiesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox/$id': {
      id: '/_app/inbox/$id'
      path: '/inbox/$id'
      fullPath: '/inbox/$id'
      preLoaderRoute: typeof AppInboxIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/guests/$id': {
      id: '/_app/guests/$id'
      path: '/guests/$id'
      fullPath: '/guests/$id'
      preLoaderRoute: typeof AppGuestsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/submit': {
      id: '/_app/finance/submit'
      path: '/submit'
      fullPath: '/finance/submit'
      preLoaderRoute: typeof AppFinanceSubmitRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/submissions': {
      id: '/_app/finance/submissions'
      path: '/submissions'
      fullPath: '/finance/submissions'
      preLoaderRoute: typeof AppFinanceSubmissionsRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/rules': {
      id: '/_app/finance/rules'
      path: '/rules'
      fullPath: '/finance/rules'
      preLoaderRoute: typeof AppFinanceRulesRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/queue': {
      id: '/_app/finance/queue'
      path: '/queue'
      fullPath: '/finance/queue'
      preLoaderRoute: typeof AppFinanceQueueRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/periods': {
      id: '/_app/finance/periods'
      path: '/periods'
      fullPath: '/finance/periods'
      preLoaderRoute: typeof AppFinancePeriodsRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/events': {
      id: '/_app/finance/events'
      path: '/events'
      fullPath: '/finance/events'
      preLoaderRoute: typeof AppFinanceEventsRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/bookings/$id': {
      id: '/_app/bookings/$id'
      path: '/bookings/$id'
      fullPath: '/bookings/$id'
      preLoaderRoute: typeof AppBookingsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apartments/new': {
      id: '/_app/apartments/new'
      path: '/apartments/new'
      fullPath: '/apartments/new'
      preLoaderRoute: typeof AppApartmentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apartments/$id': {
      id: '/_app/apartments/$id'
      path: '/apartments/$id'
      fullPath: '/apartments/$id'
      preLoaderRoute: typeof AppApartmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finance/movements/': {
      id: '/_app/finance/movements/'
      path: '/movements'
      fullPath: '/finance/movements/'
      preLoaderRoute: typeof AppFinanceMovementsIndexRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/accounts/': {
      id: '/_app/finance/accounts/'
      path: '/accounts'
      fullPath: '/finance/accounts/'
      preLoaderRoute: typeof AppFinanceAccountsIndexRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/rules/$id': {
      id: '/_app/finance/rules/$id'
      path: '/$id'
      fullPath: '/finance/rules/$id'
      preLoaderRoute: typeof AppFinanceRulesIdRouteImport
      parentRoute: typeof AppFinanceRulesRoute
    }
    '/_app/finance/movements/$id': {
      id: '/_app/finance/movements/$id'
      path: '/movements/$id'
      fullPath: '/finance/movements/$id'
      preLoaderRoute: typeof AppFinanceMovementsIdRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/expected/$id': {
      id: '/_app/finance/expected/$id'
      path: '/expected/$id'
      fullPath: '/finance/expected/$id'
      preLoaderRoute: typeof AppFinanceExpectedIdRouteImport
      parentRoute: typeof AppFinanceRoute
    }
    '/_app/finance/accounts/$id': {
      id: '/_app/finance/accounts/$id'
      path: '/accounts/$id'
      fullPath: '/finance/accounts/$id'
      preLoaderRoute: typeof AppFinanceAccountsIdRouteImport
      parentRoute: typeof AppFinanceRoute
    }
  }
}

interface AppFinanceRulesRouteChildren {
  AppFinanceRulesIdRoute: typeof AppFinanceRulesIdRoute
}

const AppFinanceRulesRouteChildren: AppFinanceRulesRouteChildren = {
  AppFinanceRulesIdRoute: AppFinanceRulesIdRoute,
}

const AppFinanceRulesRouteWithChildren = AppFinanceRulesRoute._addFileChildren(
  AppFinanceRulesRouteChildren,
)

interface AppFinanceRouteChildren {
  AppFinanceEventsRoute: typeof AppFinanceEventsRoute
  AppFinancePeriodsRoute: typeof AppFinancePeriodsRoute
  AppFinanceQueueRoute: typeof AppFinanceQueueRoute
  AppFinanceRulesRoute: typeof AppFinanceRulesRouteWithChildren
  AppFinanceSubmissionsRoute: typeof AppFinanceSubmissionsRoute
  AppFinanceSubmitRoute: typeof AppFinanceSubmitRoute
  AppFinanceIndexRoute: typeof AppFinanceIndexRoute
  AppFinanceAccountsIdRoute: typeof AppFinanceAccountsIdRoute
  AppFinanceExpectedIdRoute: typeof AppFinanceExpectedIdRoute
  AppFinanceMovementsIdRoute: typeof AppFinanceMovementsIdRoute
  AppFinanceAccountsIndexRoute: typeof AppFinanceAccountsIndexRoute
  AppFinanceMovementsIndexRoute: typeof AppFinanceMovementsIndexRoute
}

const AppFinanceRouteChildren: AppFinanceRouteChildren = {
  AppFinanceEventsRoute: AppFinanceEventsRoute,
  AppFinancePeriodsRoute: AppFinancePeriodsRoute,
  AppFinanceQueueRoute: AppFinanceQueueRoute,
  AppFinanceRulesRoute: AppFinanceRulesRouteWithChildren,
  AppFinanceSubmissionsRoute: AppFinanceSubmissionsRoute,
  AppFinanceSubmitRoute: AppFinanceSubmitRoute,
  AppFinanceIndexRoute: AppFinanceIndexRoute,
  AppFinanceAccountsIdRoute: AppFinanceAccountsIdRoute,
  AppFinanceExpectedIdRoute: AppFinanceExpectedIdRoute,
  AppFinanceMovementsIdRoute: AppFinanceMovementsIdRoute,
  AppFinanceAccountsIndexRoute: AppFinanceAccountsIndexRoute,
  AppFinanceMovementsIndexRoute: AppFinanceMovementsIndexRoute,
}

const AppFinanceRouteWithChildren = AppFinanceRoute._addFileChildren(
  AppFinanceRouteChildren,
)

interface AppRouteChildren {
  AppAutomationScheduledRoute: typeof AppAutomationScheduledRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppFinanceRoute: typeof AppFinanceRouteWithChildren
  AppRulesRoute: typeof AppRulesRoute
  AppTemplatesRoute: typeof AppTemplatesRoute
  AppWebhooksRoute: typeof AppWebhooksRoute
  AppIndexRoute: typeof AppIndexRoute
  AppApartmentsIdRoute: typeof AppApartmentsIdRoute
  AppApartmentsNewRoute: typeof AppApartmentsNewRoute
  AppBookingsIdRoute: typeof AppBookingsIdRoute
  AppGuestsIdRoute: typeof AppGuestsIdRoute
  AppInboxIdRoute: typeof AppInboxIdRoute
  AppPricingStrategiesIdRoute: typeof AppPricingStrategiesIdRoute
  AppSettingsChannelsRoute: typeof AppSettingsChannelsRoute
  AppSettingsFinanceRoute: typeof AppSettingsFinanceRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppApartmentsIndexRoute: typeof AppApartmentsIndexRoute
  AppBookingsIndexRoute: typeof AppBookingsIndexRoute
  AppGuestsIndexRoute: typeof AppGuestsIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppPricingStrategiesIndexRoute: typeof AppPricingStrategiesIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAutomationScheduledRoute: AppAutomationScheduledRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppFinanceRoute: AppFinanceRouteWithChildren,
  AppRulesRoute: AppRulesRoute,
  AppTemplatesRoute: AppTemplatesRoute,
  AppWebhooksRoute: AppWebhooksRoute,
  AppIndexRoute: AppIndexRoute,
  AppApartmentsIdRoute: AppApartmentsIdRoute,
  AppApartmentsNewRoute: AppApartmentsNewRoute,
  AppBookingsIdRoute: AppBookingsIdRoute,
  AppGuestsIdRoute: AppGuestsIdRoute,
  AppInboxIdRoute: AppInboxIdRoute,
  AppPricingStrategiesIdRoute: AppPricingStrategiesIdRoute,
  AppSettingsChannelsRoute: AppSettingsChannelsRoute,
  AppSettingsFinanceRoute: AppSettingsFinanceRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppApartmentsIndexRoute: AppApartmentsIndexRoute,
  AppBookingsIndexRoute: AppBookingsIndexRoute,
  AppGuestsIndexRoute: AppGuestsIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppPricingStrategiesIndexRoute: AppPricingStrategiesIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
